import * as React from "react";
import { useState, useCallback } from "react";
import SharedEntitiesOverview from "components/permissions/SharedEntitiesOverview";
import SectionComponent from "components/common/Section/SectionComponent";
import TeamsDomain from "../../domainActions/TeamsDomain";
const SharedEntitiesSection = ({ teamId }) => {
  const [loading, setLoading] = useState(false);
  const _searchPaginated = useCallback(
    (pagination) => TeamsDomain.loadTeamSharesPaginated(teamId, pagination),
    [teamId]
  );
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Shared Entities", showLoading: loading }, /* @__PURE__ */ React.createElement(SharedEntitiesOverview, { setLoading, entityType: "team", searchPaginated: _searchPaginated }));
};
export default SharedEntitiesSection;
